module.exports = new __parcel__URL__("roles-picker-actions-skeleton.tpl.f00bf878.svg").toString();